import axios from "axios";
import SerproConfig from "./Serpro.config";
import { SerproAuthors, SerproMeiPendenciesDict, SerproRequest, UserPendenciesDTO } from "./Serpro.type";

export interface PendencyDto {
    periodoApuracao: string;
    tributo: string;
    valor: string;
    enteFederado: string;
    situacaoDebito: string;
}

export interface PendenciesDto {
    [key: string]: PendencyDto[];
}

export interface UserDataDto {
    cnpj: string;
    cpf: string;
    email: string;
    phone: string;
    data: Record<string, unknown>;
    totalPendencies: string;
    pendencies?: SerproMeiPendenciesDict;
}

export class SerproService {
    static getAutores(clientCNPJ: string): SerproAuthors {
        return {
            AutorPedidoDados: {
                numero: SerproConfig.cnpj,
                tipo: 2,
            },
            Contratante: {
                numero: SerproConfig.cnpj,
                tipo: 2,
            },
            Contribuinte: {
                numero: clientCNPJ,
                tipo: 2,
            },
        };
    }

    static sendEmail(data: UserDataDto) {
        return axios.post("email/send", data, {
            baseURL: SerproConfig.url,
        });
    }

    static sendPendenciesEmail(data: UserPendenciesDTO) {
        return axios.post("email/send-pendencies", data, {
            baseURL: SerproConfig.url,
        });
    }

    static getDasPartialPendencies(CNPJ: string) {
        const data: { cnpj: string } = {
            cnpj: CNPJ,
        };

        return axios.post("/serpro/consultar-das-parcial", data, {
            baseURL: SerproConfig.url,
            timeout: 120 * 1000,
        });
    }

    static getDasCompletePendencies(data: { cnpj: string; email: string; name: string }) {
        return axios.post("/serpro/consultar-das-completa", data, {
            baseURL: SerproConfig.url,
            timeout: 120 * 1000,
        });
    }

    static getDividaAtivaPendencies(CNPJ: string) {
        const data: { cnpj: string } = {
            cnpj: CNPJ,
        };

        return axios.post("/serpro/consultar-divida-ativa", data, {
            baseURL: SerproConfig.url,
            timeout: 120 * 1000,
        });
    }

    static getCCMEI(cnpj: string){
        return axios.post("/serpro/consultar-dados", {
            cnpj
        }, {
            baseURL: SerproConfig.url,
            timeout: 120 * 1000,
        });
    }
}

export default SerproService;
